// extracted by mini-css-extract-plugin
module.exports = {"isSortable":"Table_isSortable__1OJNc","isCurrentSort":"Table_isCurrentSort__1TYnd","tableIcon":"Table_tableIcon__1k3db","level":"Table_level__-2bAd","stats":"Table_stats__1R210"};